
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"57","height":"40","viewBox":"9 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"57","height":"40","rx":"4","fill":"#00A769","fill-opacity":"0.1"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.375 13C15.6187 13 15.0069 13.63 15.0069 14.4L15 25.6C15 26.37 15.6119 27 16.3681 27H24.625C25.3813 27 26 26.37 26 25.6V17.781C26 17.41 25.8556 17.053 25.5944 16.794L22.2737 13.413C22.0194 13.147 21.6688 13 21.3044 13H16.375ZM21.1875 17.2V14.05L24.9688 17.9H21.875C21.4969 17.9 21.1875 17.585 21.1875 17.2Z","fill":"#00A769"}})])
          )
        }
      }
    